type ManagePlanQuantityStepperProps = {
  value: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange: (value: number) => void;
};

export function ManagePlanQuantityStepper({
  value,
  min = 1,
  max = 99,
  disabled = false,
  onChange,
}: ManagePlanQuantityStepperProps) {
  const decrementDisabled = disabled || value <= min;
  const incrementDisabled = disabled || value >= max;

  return (
    <div className="flex w-full items-center gap-1.5">
      <button
        type="button"
        disabled={decrementDisabled}
        onClick={() => onChange(Math.max(min, value - 1))}
        className="flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-gray-200 bg-white text-xl leading-none text-gray-700 shadow-[0_1px_2px_rgba(0,0,0,0.05)] transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
      >
        -
      </button>
      <div className="flex h-11 flex-1 items-center justify-center rounded-xl border border-gray-200 bg-white px-4 text-base font-semibold text-gray-950 shadow-[0_1px_2px_rgba(0,0,0,0.05)]">
        {value}
      </div>
      <button
        type="button"
        disabled={incrementDisabled}
        onClick={() => onChange(Math.min(max, value + 1))}
        className="flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-gray-200 bg-white text-xl leading-none text-gray-700 shadow-[0_1px_2px_rgba(0,0,0,0.05)] transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
      >
        +
      </button>
    </div>
  );
}
